import { defineComponent, createBlock, openBlock, withCtx, createVNode, createElementVNode, toDisplayString, createElementBlock, ref, onBeforeMount, createCommentVNode, defineAsyncComponent } from "vue";
import { getI18n, registerEntityEndpoint, getClient, BfBrandIcon, getBaseUrlForBrand } from "@editor/ui-utils";
import { QIcon, QBtn, QImg } from "quasar";
import { useI18n } from "vue-i18n";
import EditorImagePlaceholder from "@modules/image-editor-ui/src/components/editor-image-placeholder.vue";
import { getImageUrl } from "@modules/image-editor-ui/src/services/image.service";
import { defineStore } from "pinia";
const de = {
  peopleProfile: {
    firstName: "Vorname",
    lastName: "Nachname",
    birthDate: "Geburtsdatum",
    deathDate: "Todesdatum",
    birthPlace: "Geburtsort",
    size: "Größe (cm)",
    zodiacSign: "Sternzeichen",
    zodiacSigns: {
      aquarius: "Wassermann",
      pisces: "Fische",
      aries: "Widder",
      taurus: "Stier",
      gemini: "Zwillinge",
      cancer: "Krebs",
      leo: "Löwe",
      virgo: "Jungfrau",
      libra: "Waage",
      scorpio: "Skorpion",
      sagittarius: "Schütze",
      capricorn: "Steinbock"
    }
  },
  tagsApi: {
    createAlreadyExists: "Tag kann nicht erstellt werden, da bereits ein Tag mit diesem Namen existiert",
    updateAlreadyExists: "Tag kann nicht aktualisiert werden, da bereits ein Tag mit diesem Namen existiert",
    created: "Tag erstellt",
    updated: "Tag aktualisiert",
    notFound: "Tag nicht gefunden",
    requiredFields: "Sie können den Tag nicht speichern, da obligatorische Informationen fehlen"
  },
  tagsList: {
    newButton: "Neuer Tag",
    name: "Nach Name suchen",
    deleteTag: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Tag",
    headerLabel: "Tag",
    headerRelatedTags: "Ähnliche Tags",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert",
    headerPublishedAt: "Veröffentlicht",
    headerTagType: "Typ",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createTag: "Tag erstellen",
    headerStatus: "Status",
    type: "Typ",
    noEditTooltip: "Dieser Tag stammt ursprünglich vom {source}-Editor"
  },
  tags: {
    tagsLabel: "Tag",
    backButton: "Zurück zur Tag-Liste",
    newTag: "Neues Tag",
    messageDeleteTag: "Tag löschen",
    messageDeleteTagTitle: "Sind Sie sicher, dass Sie dieses Tag löschen möchten?",
    deleteTag: "Löschen",
    messageDeleted: "Tag gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Tags",
    errorFailedLoadedTagWithId: "Es gab einen Fehler beim Abrufen des Tags",
    handledInLegacySystem: "Dieser Tag wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten",
    peopleTab: "Person bearbeiten",
    profile: "Steckbrief",
    imageSelector: "Bild auswählen oder hochladen"
  },
  tagsEdit: {
    title: "Tag Titel",
    type: "Tag Typ",
    counter: "Zähler",
    backButton: "Zurück zur Tag-Liste",
    editTag: "Tag bearbeiten",
    messageSaved: "Tag gespeichert",
    linkTags: "Ähnliche Tags",
    urlSlug: "URL Slug",
    toTag: "Zum Tag",
    generatePath: "Pfad automatisch generieren",
    showOnListPage: "Tag auf Übersichtsseite anzeigen",
    publishSettings: "Veröffentlichung",
    publishDate: "Veröffentlichen am",
    unpublishDate: "Offline nehmen am",
    shownDate: "Angezeigtes Datum",
    deleteTag: "Tag löschen",
    duplicateTag: "Tag duplizieren",
    duplicateTagMessage: "Sind Sie sicher, dass Sie dieses Tag duplizieren möchten?",
    duplicate: "Duplizieren",
    takeOffline: "Offline gehen",
    selectTag: "Tag auswählen",
    nowLabel: "Auf Jetzt Einstellen",
    saveAsDraft: "Als Entwurf speichern",
    updateShownDate: "Angezeigtes Datum aktualisieren",
    updateShownDatePopup: "Aktualisieren Sie das Shown Date automatisch auf den aktuallen Zeitstempel, wenn Sie den Artikel speichern oder veröffentlichen.",
    modeUnpublished: "Offline genommen",
    modeScheduled: "Veröffentlichung geplant",
    modePublished: "Veröffentlicht",
    modeDraft: "Entwurf"
  },
  tagType: { people: "Person", brand: "Marke" },
  tagsMigration: {
    directEditNotice: "Bitte beachten Sie: Die hier sichtbaren Einstellungen wirken sofort und unabhängig von der Speichern-Funktion. Änderungen treten unmittelbar in Kraft.",
    source: "Herkunft",
    legacyId: "Legacy ID",
    renderedByCtf: "Darstellung durch CTF",
    editableInCtf: "Bearbeitung in Vibe",
    modifiedInCtf: "Geändert in Vibe",
    confirmModal: {
      yes: "Ja",
      cancel: "Abbrechen",
      renderedBy: {
        title: "Darstellung durch CTF ändern",
        message: "Bist du sicher, dass du das darstellende System ändern möchtest?"
      },
      editableIn: {
        title: "Bearbeitung in Vibe ändern",
        message: "Bist du sicher, dass du die Bearbeitung in Vibe erlauben möchtest? Das kann nicht rückgängig gemacht werden!"
      }
    },
    viewCtfVersion: "CTF-Version öffnen"
  }
};
const en = {
  peopleProfile: {
    firstName: "First Name",
    lastName: "Last Name",
    birthDate: "Birth Date",
    deathDate: "Date of Death",
    birthPlace: "Place of Birth",
    size: "Size (cm)",
    zodiacSign: "Zodiac Sign",
    zodiacSigns: {
      aquarius: "Aquarius",
      pisces: "Pisces",
      aries: "Aries",
      taurus: "Taurus",
      gemini: "Gemini",
      cancer: "Cancer",
      leo: "Leo",
      virgo: "Virgo",
      libra: "Libra",
      scorpio: "Scorpio",
      sagittarius: "Sagittarius",
      capricorn: "Capricorn"
    }
  },
  tagsApi: {
    createAlreadyExists: "Can't create Tag because another Tag with this name already exists",
    updateAlreadyExists: "Can't update Tag because another Tag with this name already exists",
    created: "Tag created",
    updated: "Tag updated",
    notFound: "Tag not found",
    requiredFields: "You can't save the Tag because mandatory information is missing"
  },
  tagsList: {
    newButton: "New Tag",
    name: "Search by tag",
    deleteTag: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Tag",
    headerLabel: "Tag",
    headerRelatedTags: "Related Tags",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    headerPublishedAt: "Published at",
    headerTagType: "Type",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createTag: "Create Tag",
    headerStatus: "Status",
    type: "Type",
    noEditTooltip: "This tag is originally from the {source} editor"
  },
  tags: {
    tagsLabel: "Tag",
    backButton: "Back to Tag list",
    newTag: "New Tag",
    messageDeleteTag: "Delete Tag",
    messageDeleteTagTitle: "Are you sure you want to delete this Tag?",
    deleteTag: "Delete",
    messageDeleted: "Tag Deleted",
    errorOnDeleting: "There was an error deleting the Tag ",
    errorFailedLoadedTagWithId: "There was an error getting the Tag",
    handledInLegacySystem: "This Tag is being handled in {source}, you can't edit it on Vibe",
    peopleTab: "Edit Person",
    profile: "Profile",
    imageSelector: "Select or upload main image"
  },
  tagsEdit: {
    title: "Tag Title",
    type: "Tag Type",
    counter: "Counter",
    backButton: "Back to Tag list",
    editTag: "Edit Tag",
    messageSaved: "Tag saved",
    linkTags: "Link Tags",
    urlSlug: "URL Slug",
    toTag: "To Tag",
    generatePath: "Automatically generate path",
    showOnListPage: "Show on overview page",
    publishSettings: "Publishing Settings",
    publishDate: "Publish Date",
    unpublishDate: "Take offline at",
    shownDate: "Shown Date",
    deleteTag: "Delete Tag",
    duplicateTag: "Duplicate Tag",
    duplicateTagMessage: "Are you sure you want to duplicate this Tag?",
    duplicate: "Duplicate",
    takeOffline: "Take offline",
    selectTag: "Select Tag",
    nowLabel: "Set to now",
    saveAsDraft: "Save as draft",
    updateShownDate: "Update Shown Date",
    updateShownDatePopup: "Automatically update the shown date to the current timestamp when you save or publish the article.",
    modeUnpublished: "Tag offline",
    modeScheduled: "Publishing date scheduled",
    modePublished: "Published",
    modeDraft: "Draft"
  },
  tagsMigration: {
    directEditNotice: "Please note: The settings visible here take effect immediately and are independent of the save function. Changes are applied instantly.",
    source: "Source",
    legacyId: "Legacy ID",
    renderedByCtf: "Rendered by CTF",
    editableInCtf: "Editable in Vibe",
    modifiedInCtf: "Modified in Vibe",
    confirmModal: {
      yes: "Yes",
      cancel: "Cancel",
      renderedBy: {
        title: "Changing Rendered by CTF",
        message: "Are you sure you want to change the rendering system?"
      },
      editableIn: {
        title: "Changing Editable in Vibe",
        message: "Are you sure you want to make the channel editable in CTF? This cannot be undone!"
      }
    },
    viewCtfVersion: "View CTF version"
  },
  tagType: { people: "People", brand: "Brand" }
};
const messages = { en, de };
const routes = [
  {
    path: "/tags",
    children: [
      {
        path: "",
        name: "tags_list",
        component: () => import("./tags-list.view-DXhfZQ3S.js").then((n) => n.t),
        meta: { requiredRight: "navigate_list_tags" }
      },
      {
        path: "new",
        name: "tags_new",
        component: () => import("./tags-edit.view-C_MmVakU.js"),
        props: () => ({
          title: getI18n().t("tags.newTag"),
          backRoute: "/tags"
        }),
        meta: { requiredRight: ["navigate_tags"] }
      },
      {
        path: ":id",
        name: "tags_detail",
        component: () => import("./tags-edit.view-C_MmVakU.js"),
        props: (route) => ({
          title: getI18n().t("tags.editTag"),
          id: route.params.id,
          backRoute: "/tags"
        }),
        meta: { requiredRight: ["navigate_tags"] }
      }
    ]
  }
];
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "tags-link-tags-button",
  props: {
    canEdit: { type: Boolean, required: false, default: true }
  },
  emits: ["click:linkTags"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const emit = __emit;
    const __returned__ = { t, emit, get QBtn() {
      return QBtn;
    }, get QIcon() {
      return QIcon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QBtn"], {
    "data-qa-tags-link-tags-button": "",
    disable: !$props.canEdit,
    "text-color": "secondary",
    style: { "background-color": "white !important" },
    outline: "",
    class: "q-mr-sm linkTagsButton",
    onClick: _cache[0] || (_cache[0] = ($event) => $setup.emit("click:linkTags"))
  }, {
    default: withCtx(() => [
      createVNode($setup["QIcon"], {
        name: "plus",
        class: "q-mr-sm",
        color: "primary"
      }),
      createElementVNode(
        "span",
        null,
        toDisplayString($setup.t("articlesEdit.linkTags")),
        1
        /* TEXT */
      )
    ]),
    _: 1
    /* STABLE */
  }, 8, ["disable"]);
}
const TagsLinkTagsButton = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-aca36880"], ["__file", "/builds/CT/content-technology-framework/modules/tags/editor-ui/src/components/tags-link-tags-button.vue"]]);
const entityEndpoint = "tags";
const TagsService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities, putEntity, postEntity, deleteEntity } = TagsService;
const getTag = async (id) => {
  return getEntity(id);
};
const postTag = async (tag) => {
  return postEntity(tag);
};
const putTag = async (tag) => {
  const { _id, ...payload } = tag;
  return putEntity(_id, payload);
};
const deleteTag = async (id) => {
  return deleteEntity(id);
};
const updateLegacyMigration = async (tagUuid, data) => {
  const client = getClient();
  const response = await client.put(`/cms/tags/${tagUuid}/legacy-migration`, data);
  return response.data;
};
const tagsTypes = ["People"];
const blockMatchers = [{ tagsType: "People", blockType: "PEOPLE_PROFILE", icon: "star" }];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "tags-type-pill",
  props: {
    type: { type: String, required: false, default: "People" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const getIcon = () => {
      var _a;
      return ((_a = blockMatchers.find((blockMatcher) => blockMatcher.tagsType === props.type)) == null ? void 0 : _a.icon) || "help";
    };
    const __returned__ = { props, getIcon, get QIcon() {
      return QIcon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = { class: "relatedTagPill q-px-sm" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    createVNode($setup["QIcon"], {
      name: $setup.getIcon(),
      class: "q-mr-sm q-my-auto",
      color: "white"
    }, null, 8, ["name"]),
    createElementVNode(
      "span",
      null,
      toDisplayString($props.type),
      1
      /* TEXT */
    )
  ]);
}
const TagsTypePill = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-e43c3e8d"], ["__file", "/builds/CT/content-technology-framework/modules/tags/editor-ui/src/components/tags-type-pill.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "tags-related-tag",
  props: {
    relatedTag: { type: String, required: false, default: "" }
  },
  emits: ["click:remove-tag"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const relatedTagData = ref();
    let relatedTagImage;
    const props = __props;
    onBeforeMount(async () => {
      var _a, _b, _c;
      if (props.relatedTag !== void 0) {
        try {
          relatedTagData.value = await getTag(props.relatedTag);
        } catch (error) {
          console.error(error);
        }
        if (!relatedTagData.value || relatedTagData.value.state !== "publish") {
          emit("click:remove-tag", props.relatedTag);
          return;
        }
        if ((_b = (_a = relatedTagData.value) == null ? void 0 : _a.pageMetadata) == null ? void 0 : _b.imageUuid) {
          relatedTagImage = getImageUrl(((_c = relatedTagData.value.pageMetadata) == null ? void 0 : _c.imageUuid) ?? "", 100, 100);
        } else {
          relatedTagImage = "";
        }
      }
    });
    const __returned__ = { emit, relatedTagData, get relatedTagImage() {
      return relatedTagImage;
    }, set relatedTagImage(v) {
      relatedTagImage = v;
    }, props, get BfBrandIcon() {
      return BfBrandIcon;
    }, EditorImagePlaceholder, get QBtn() {
      return QBtn;
    }, get QImg() {
      return QImg;
    }, TagsTypePill };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = {
  key: 0,
  class: "relatedTagContainer q-mr-md q-mb-md",
  outlined: ""
};
const _hoisted_2 = {
  "data-qa-related-tag-image": "",
  class: "relatedTagImage"
};
const _hoisted_3 = { class: "relatedTagMiddle q-ml-md q-my-auto text-left" };
const _hoisted_4 = {
  "data-qa-related-tag-title": "",
  class: "relatedTagTitle q-ml-xs"
};
const _hoisted_5 = { class: "relatedTagDetails q-mr-sm q-ml-auto" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  return $setup.relatedTagData ? (openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, [
      $setup.relatedTagImage !== "" ? (openBlock(), createBlock($setup["QImg"], {
        key: 0,
        "data-qa-preview": "",
        class: "custom-image",
        src: $setup.relatedTagImage
      }, null, 8, ["src"])) : (openBlock(), createBlock($setup["EditorImagePlaceholder"], {
        key: 1,
        class: "custom-image"
      }))
    ]),
    createElementVNode("div", _hoisted_3, [
      ((_a = $setup.relatedTagData.pageMetadata) == null ? void 0 : _a.type) ? (openBlock(), createBlock($setup["TagsTypePill"], {
        key: 0,
        "data-qa-related-tag-type": ""
      })) : createCommentVNode("v-if", true),
      createElementVNode(
        "span",
        _hoisted_4,
        toDisplayString($setup.relatedTagData.title),
        1
        /* TEXT */
      )
    ]),
    createElementVNode("div", _hoisted_5, [
      $setup.relatedTagData.brand ? (openBlock(), createBlock($setup["BfBrandIcon"], {
        key: 0,
        class: "q-mx-md",
        brand: $setup.relatedTagData.brand,
        small: ""
      }, null, 8, ["brand"])) : createCommentVNode("v-if", true),
      createVNode($setup["QBtn"], {
        icon: "close",
        flat: "",
        dense: "",
        class: "relatedTagRemoveButton",
        onClick: _cache[0] || (_cache[0] = ($event) => $setup.emit("click:remove-tag", $props.relatedTag))
      })
    ])
  ])) : createCommentVNode("v-if", true);
}
const TagsRelatedTag = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-522ebe38"], ["__file", "/builds/CT/content-technology-framework/modules/tags/editor-ui/src/components/tags-related-tag.vue"]]);
const getContentUrl = (content, tagsUrlConfig) => {
  var _a;
  const { hasCtfOverride } = tagsUrlConfig || {};
  const brand = content.brand;
  const state = content.state.toUpperCase();
  const baseUrl = getBaseUrlForBrand(brand, state);
  let path = "";
  if (content.pageMetadata === void 0) {
    return "";
  }
  if (content.state !== "publish") {
    path = `themaPreview/_id_${content._id}.html`;
  } else if (!!content.paths && (content.paths.length ?? 0) > 0) {
    path = ((_a = content.paths[content.paths.length - 1]) == null ? void 0 : _a.path) || "";
  } else {
    path = "";
  }
  const url = new URL(path, baseUrl);
  if (hasCtfOverride) {
    url.searchParams.append("ctf", "override");
  }
  return url.toString();
};
function getTagCanonicalUrl(urlSlug, id, brand) {
  if (brand === "bunte") {
    return `/thema/starprofile/${urlSlug}_${id}.html`;
  } else {
    return `/thema/person/${urlSlug}_${id}.html`;
  }
}
const useTagsStore = defineStore("tagsStore", {
  state: () => ({
    loading: false,
    tag: {
      publishDate: void 0,
      state: "draft",
      brand: "bunte",
      title: "",
      relatedTagsUuids: [],
      urlSlug: "",
      paths: [],
      contentsRef: [],
      pageMetadata: {
        type: "People",
        imageUuid: "",
        lastName: ""
      },
      legacy: {
        source: "vibe",
        isEditableInCTF: true,
        hasBeenModifiedInCTF: true,
        isRenderedByCTF: true
      },
      showOnListPage: false
    }
  }),
  actions: {
    async createTag() {
      var _a;
      this.loading = true;
      try {
        const { _id } = await postTag(this.tag);
        this.tag._id = _id;
        this.loading = false;
        const path = getTagCanonicalUrl(this.tag.urlSlug, _id, this.tag.brand);
        if (!this.tag.paths) {
          this.tag.paths = [];
        }
        if (path !== ((_a = this.tag.paths.at(-1)) == null ? void 0 : _a.path)) {
          this.tag.paths.push({
            path,
            brand: this.tag.brand,
            type: this.isDefaultSlug() ? "generated" : "custom",
            createDate: /* @__PURE__ */ new Date()
          });
        }
        await this.updateTag();
        return _id;
      } catch (e) {
        this.loading = false;
      }
      return "";
    },
    async updateTag() {
      var _a;
      if (!this.tag._id)
        return;
      this.loading = true;
      const path = getTagCanonicalUrl(this.tag.urlSlug, this.tag._id, this.tag.brand);
      if (!this.tag.paths) {
        this.tag.paths = [];
      }
      if (path !== ((_a = this.tag.paths.at(-1)) == null ? void 0 : _a.path)) {
        this.tag.paths.push({
          brand: this.tag.brand,
          path,
          type: this.isDefaultSlug() ? "generated" : "custom",
          createDate: /* @__PURE__ */ new Date()
        });
      }
      if (this.tag.displayDate === void 0 || this.tag.publishDate && this.tag.displayDate < this.tag.publishDate) {
        this.tag.displayDate = this.tag.publishDate;
      }
      if (this.tag.publishDate && this.tag.publishDate > /* @__PURE__ */ new Date()) {
        this.tag.state = "schedule";
      }
      this.tag.legacy.hasBeenModifiedInCTF = true;
      try {
        await putTag({ ...this.tag, _id: this.tag._id });
      } catch (e) {
      }
      this.loading = false;
    },
    async duplicateTag() {
      this.loading = true;
      const createRequest = {
        state: "draft",
        brand: "bunte",
        title: "",
        relatedTagsUuids: this.tag.relatedTagsUuids,
        pageMetadata: this.tag.pageMetadata,
        paths: [],
        contentsRef: this.tag.contentsRef,
        legacy: this.tag.legacy,
        showOnListPage: this.tag.showOnListPage
      };
      try {
        await postTag(createRequest);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async deleteTag() {
      if (!this.tag._id)
        return;
      this.loading = true;
      try {
        await deleteTag(this.tag._id);
      } catch (e) {
      }
      this.loading = false;
    },
    async unpublishTag() {
      if (!this.tag._id)
        return;
      this.tag.state = "unpublish";
      this.tag.publishDate = void 0;
      this.tag.unpublishDate = /* @__PURE__ */ new Date();
      this.loading = true;
      try {
        await putTag({ ...this.tag, _id: this.tag._id });
      } catch (e) {
      }
      this.loading = false;
    },
    updateBlocksArray(blocksArray) {
      this.tag.contentsRef = blocksArray;
    },
    getDefaultSlug() {
      return this.tag.title.toLowerCase().replace(/ /g, "-");
    },
    isDefaultSlug() {
      return this.getDefaultSlug() === this.tag.urlSlug;
    }
  }
});
const PeopleProfileBlock = defineAsyncComponent(() => import("./people-profile-block-B9pyUPjw.js"));
const TagsListView = defineAsyncComponent(() => import("./tags-list.view-DXhfZQ3S.js").then((n) => n.t));
const tagsModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "PEOPLE_PROFILE",
      label: "tags.profile",
      icon: "star",
      component: PeopleProfileBlock,
      defaultValue: { type: "PEOPLE_PROFILE", imageUuid: "", lastName: "" }
    }
  ]
};
export {
  PeopleProfileBlock as P,
  TagsRelatedTag as T,
  _export_sfc as _,
  TagsLinkTagsButton as a,
  updateLegacyMigration as b,
  getTag as c,
  TagsService as d,
  deleteTag as e,
  TagsListView as f,
  getContentUrl as g,
  tagsModule as h,
  tagsTypes as t,
  useTagsStore as u
};
//# sourceMappingURL=index-BoHPol5y.js.map
